/** Materials for the miniature ballpark, separate from the application's UI theme. */
export const fieldPalette = {
  sky: '#a5bcc7',
  ground: '#707a59',
  grass: '#4f7938',
  stripe: '#638948',
  dirt: '#be8e68',
  clay: '#d1a480',
  chalk: '#fff5db',
  wall: '#214947',
  seats: '#526b69',
  seatsLight: '#718780',
  concrete: '#838a7c',
  defense: '#294c78',
  runner: '#e17842',
  pants: '#eee9d9',
  skin: '#c89169',
  shoes: '#233532',
  selection: '#ffcc6f',
  board: '#153a37'
}
